import React from "react";
import MainPage from "../Components/MainPage";

const Home = () => {
  return (
    <div>
      <MainPage />
    </div>
  );
};

export default Home;
